<template>
  <div class="extra-option">
    <div class="md-layout md-alignment-top-left">
      <div class="md-layout-item md-size-50">
        <md-field>
          <label>Name</label>
          <md-input
            :value="rule.name"
            required
            @input="updateRule('name', $event)"
          />
        </md-field>
      </div>

      <div class="md-layout-item md-size-50">
        <md-field class="option-select">
          <label>Applies to</label>
          <md-select
            :value="rule.applies_to.value"
            @input="onSelectValue('applies_to', $event)"
          >
            <md-option
              v-for="type in appliesToTypes"
              :key="type.value"
              :value="type.value"
            >
              {{ type.key }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-top-left">
      <div class="md-layout-item md-size-33">
        <md-field class="option-select">
          <label>Discount Type</label>
          <md-select
            :value="rule.amount_type.value"
            @input="onSelectValue('amount_type', $event)"
          >
            <md-option
              v-for="type in amountTypes"
              :key="type.value"
              :value="type.value"
            >
              {{ type.key }}
            </md-option>
          </md-select>
        </md-field>
      </div>

      <div class="md-layout-item md-size-33">
        <md-field class="md-form-group" slot="inputs">
          <md-icon v-if="rule.amount_type.value === 'fixed'">
            <i class="fas fa-pound-sign text-primary hi-price-icon"></i>
          </md-icon>
          <md-icon v-else-if="rule.amount_type.value === 'percentage'">
            <i class="fas fa-percent text-primary hi-price-icon"></i>
          </md-icon>
          <label>Amount</label>
          <md-input
            :value="rule.amount"
            type="text"
            @input="updateRule('amount', $event)"
          />
        </md-field>
      </div>

      <div class="md-layout-item md-size-33">
        <md-switch v-model="includeExtras">
          Include Extras
        </md-switch>
      </div>
    </div>

    <div class="md-layout mt-2">
      <div class="md-layout-item md-size-100 text-right">
        <md-button
          v-if="isDirty"
          class="md-icon-button md-dense md-primary md-simple"
          :disabled="saving || !canSave"
          @click="onSaveRule"
        >
          <md-icon>save</md-icon>
        </md-button>
        <md-button
          class="md-icon-button md-dense md-danger md-simple"
          :disabled="saving"
          @click="onDeleteRule"
        >
          <md-icon>clear</md-icon>
          <md-tooltip md-direction="top">Delete this Rule</md-tooltip>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DiscountRule",

  props: {
    rule: { type: Object, required: true },
    index: { type: Number, required: true }
  },

  data() {
    return {
      saving: false,
      isDirty: false,
      appliesToTypes: [
        { value: "leadbooker", key: "Lead Booker" },
        { value: "travellers", key: "Travellers" },
        { value: "everyone", key: "Everyone" }
      ],
      amountTypes: [
        { value: "fixed", key: "Fixed" },
        { value: "percentage", key: "Percentage" }
      ]
    };
  },

  computed: {
    discountId() {
      return this.$store.getters["discount/selectedDiscount"]?.id;
    },
    canSave() {
      return (
        !!this.discountId &&
        this.rule.name &&
        this.rule.amount !== "" &&
        this.rule.amount_type?.value &&
        this.rule.applies_to?.value
      );
    },
    includeExtras: {
      get() {
        return !!this.rule.include_extras;
      },
      set(val) {
        this.updateRule("include_extras", !!val);
        this.isDirty = true;
      }
    }
  },

  methods: {
    ...mapActions("discount", ["updateRuleField", "saveRule", "deleteRule"]),

    updateRule(field, value) {
      this.updateRuleField({
        ruleIndex: this.index,
        field,
        value
      });
      this.isDirty = true;
    },

    onSelectValue(field, newValue) {
      const current = this.rule[field] || { value: "", key: "" };
      this.updateRule(field, { ...current, value: newValue });
      this.isDirty = true;
    },

    async onSaveRule() {
      this.saving = true;
      try {
        await this.saveRule(this.index);
        this.isDirty = false;
      } finally {
        this.saving = false;
      }
    },

    async onDeleteRule() {
      this.saving = true;
      try {
        await this.deleteRule(this.index);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.extra-option {
  border-bottom: 1px solid #00bcd4;
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
}

::v-deep .md-field .md-icon.icon-sm {
  font-size: 16px !important;
  opacity: 0.7;
}
</style>
